import type { IPublicClientApplication, AccountInfo, AuthenticationResult} from "@azure/msal-browser";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

interface IMsalAccountInfo {
  instance: IPublicClientApplication;
  account: AccountInfo;
}

let accountInfo: IMsalAccountInfo | null = null;

// Legacy function - kept for backward compatibility
export async function acquireAccessTokenAsync(msalInstance: IPublicClientApplication, account: AccountInfo, scopes: string[]): Promise<string> {
    try {
        const authResult: AuthenticationResult = await msalInstance.acquireTokenSilent({ scopes: scopes, account });
        return authResult.accessToken;
    } catch (error) {

        if (error instanceof InteractionRequiredAuthError) {
            const popupResult = await msalInstance.acquireTokenPopup({ scopes: scopes });
            return popupResult.accessToken;
        }
    }
    return '';
}

// New centralized authentication management functions
export function setActiveAccount(instance: IPublicClientApplication, accounts: AccountInfo[]): void {
  let activeAccount = instance.getActiveAccount();
  
  if (activeAccount) {
    accountInfo = {
      instance: instance,
      account: activeAccount
    };
    return;
  }

  const allAccounts = accounts.length <= 0 ? instance.getAllAccounts() : accounts;
  if (allAccounts.length <= 0) {
    accountInfo = null;
    return;
  }

  instance.setActiveAccount(allAccounts[0]);
  activeAccount = instance.getActiveAccount();

  if (!activeAccount) {
    accountInfo = null;
    return;
  }
  
  accountInfo = {
    instance: instance,
    account: activeAccount
  };
}

export async function acquireAccessTokenCentralAsync(scopes: string[]): Promise<string> {
    if (!accountInfo) {
        throw new Error("Active account not set!");
    }

    try {
        const account = accountInfo.account;
        const authResult: AuthenticationResult = await accountInfo.instance.acquireTokenSilent({ scopes: scopes, account });
        return authResult.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const popupResult = await accountInfo.instance.acquireTokenPopup({ scopes: scopes });
            return popupResult.accessToken;
        }
    }

    return '';
}

export function logout(): void {
    if (!accountInfo) {
        globalThis.location.href = "/";
        return;
    }

    void accountInfo.instance.logoutRedirect({
        postLogoutRedirectUri: "/",
    });
}